<template>
    <el-dialog
    v-model="show"
    title="趋势图"
    width="60%"
    >
        <div
        ref="TrendGraph"
        id="TrendGraph"
        :style="{ width: '100%', height: '400px'}"
        ></div>
        <!-- <div
        ref="WaveGraph"
        id="WaveGraph"
        :style="{ width: '100%', height: '400px'}"
        ></div> -->
        
        <template #footer>
        <span class="dialog-footer">
            <!-- <el-button >查看波形图</el-button>
            <el-button >关闭</el-button> -->
            <!-- <el-button type="primary" @click="dialogVisible = false"
            >Confirm</el-button
            > -->
        </span>
        </template>
  </el-dialog>
    
  </template>

<script>
import {ref, onBeforeMount ,onBeforeUnmount, onMounted,computed, watch,router,nextTick} from 'vue'
import mydark from "../../../static/halloween";
import * as echarts from "echarts";
export default {
  name: 'TrendGraph',
  setup(props, ctx) {
    // let router = useRouter();
    // let route = useRoute();
    const TmyChart=ref(null);
    

    let show=true;
    let TrendTitle="TrendTitle";
    let SpecTitle="SpecTitle";
    let TrendTimes=[];
    let myDataPoints={};
    let myChart=ref({});
    let myChart2=ref({});
    let DrawGraph=((dataX,dataY,titleText,AlarmPoints,dataPoints)=>{
        myDataPoints=dataPoints;
        TrendTimes=dataX;
        console.log("开始画图");
        echarts.registerTheme("mydark", mydark);
        document.getElementById("TrendGraph").removeAttribute("_echarts_instance_");
        myChart = echarts.init(document.getElementById('TrendGraph'),"mydark");
        var TrendOption = {
            title:{
                text:titleText,
                left:'center'
            },
            tooltip: {
                trigger: 'axis'
            },
            xAxis: {
                type: 'category',
                // data: ['1613788626000', '1613778626000', '1613788676000', '1613783626000', '1613788624000', '1613788426000', '1643788626000']
                data: dataX
            },
            yAxis: {
                name:dataPoints.unit1,
                type: 'value'
            },
            series: [
                {
                // data: [150, 230, 224, 218, 135, 147, 260],
                data: dataY,
                markPoint: {
                    symbolSize: [18, 18], // 容器大小
					symbolOffset: [0, -5], //位置偏移
                    itemStyle: {color: 'yellow'},
                    data: AlarmPoints,
                    // label: {
                    //     offset: [0, 0],
                    //     textStyle: {
                    //         color: "#5470c6",
                    //         fontSize: 15,
                    //     },
                    // },
                },
                markLine: {
                    symbol: ['none', 'none'], // none为标线两端的样式为无，可更改
                    data: [
                        {
                        silent: false,
                        xAxis: dataPoints.xIndex,  // 表现自定义的位置，可赋值
                        label: {
                            position: 'end', // 表现内容展示的位置
                            formatter: timestampToTime(dataPoints.trendTime),  // 标线展示的内容
                            color: '#8C8C8C'  // 展示内容颜色
                        },
                        lineStyle: { type: 'dashed', color: '#C1E7FF', width: 1 } // 样式： 线型、颜色、线宽
                        }
                    ]
                    },
                type: 'line'
                }
            ]
            };

        myChart.setOption(TrendOption)
        myChart.getZr().on("click", chartClick);
        // var myChart2 = echarts.init(document.getElementById('WaveGraph'),"mydark");
        // myChart2.setOption(SpecOption)
    })
    let DrawGraph2=((dataX,dataY,titleText,dataPoints)=>{
        console.log("开始画图2");
        echarts.registerTheme("mydark", mydark);

            //波形图的option
            var SpecOption = {
            title:[{
                text:titleText,
                left:'center'
            },{
                text:'['+timestampToTime(parseInt(dataPoints.trendTime))+']',
                left:'center',
                top: '7%' ,
                textStyle:{
                          fontSize: 10,//大小
                }
            }],
            tooltip: {
                trigger: 'axis'
            },
            xAxis: {
                type: 'category',
                name: dataPoints.unitx,
                data: dataX
            },
            yAxis: {
                name :dataPoints.unity,
                type: 'value'
            },
            series: [
                {
                data: dataY,
                type: 'line'
                }
            ]
            };
        document.getElementById("WaveGraph").removeAttribute("_echarts_instance_");
        myChart2 = echarts.init(document.getElementById('WaveGraph'),"mydark");
        myChart2.setOption(SpecOption)
    })
    let DrawGraphNull=((title)=>{
        console.log("开始画图空");
        echarts.registerTheme("mydark", mydark);

            //波形图的option
            var Option = {
            title:[{
                text:title,
                left:'center'
            },{
                text:"未获取到趋势图数据",
                left:'center',
                top:"50%",
                textStyle:{
                          fontSize: 30,//大小
                }
            }],
            tooltip: {
                trigger: 'axis'
            },
            xAxis: {
                type: 'category',
                data: []
            },
            yAxis: {
                type: 'value',
                max:1,
                splitLine:{
                    show:true
                }
            },
            series: [
                {
                data: [2],
                type: 'line'
                }
            ]
            };
        document.getElementById("TrendGraph").removeAttribute("_echarts_instance_");    
        myChart = echarts.init(document.getElementById('TrendGraph'),"mydark");
        myChart.setOption(Option)
        // var myChart2 = echarts.init(document.getElementById('WaveGraph'),"mydark");
        // myChart2.setOption(Option)
    })
    let chartClick=((params)=>{
        console.log('chartClick',params);
        const pointInPixel = [params.offsetX, params.offsetY];
        if (myChart.containPixel("grid", pointInPixel)) {
            let pointInGrid = myChart.convertFromPixel(
            { seriesIndex: 0 },
            pointInPixel
            );
            var xIndex = pointInGrid[0];
            var yIndex = pointInGrid[1];
            console.log("点击位置的x   y---------:",xIndex,yIndex,TrendTimes[xIndex]);
            var params=myDataPoints;
            params.trendTime=params.trendTimes[xIndex]
            var TrendOption = {
                series: [
                    {
                    markLine: {
                        symbol: ['none', 'none'], // none为标线两端的样式为无，可更改
                        data: [
                            {
                            silent: false,
                            xAxis: xIndex,  // 表现自定义的位置，可赋值
                            label: {
                                position: 'end', // 表现内容展示的位置
                                formatter: timestampToTime(params.trendTimes[xIndex]),  // 标线展示的内容
                                color: '#8C8C8C'  // 展示内容颜色
                            },
                            lineStyle: { type: 'dashed', color: '#C1E7FF', width: 1 } // 样式： 线型、颜色、线宽
                            }
                        ]
                        },
                    }
                ]
            };
            myChart.setOption(TrendOption)
            ctx.emit('DrawWave',params);
        }
    })
    let DrawGraphNull2=((title)=>{
        console.log("开始画图空");
        echarts.registerTheme("mydark", mydark);

            //波形图的option
            var Option = {
            title:[{
                text:title,
                left:'center'
            },{
                text:"未获取到波形图数据",
                left:'center',
                top:"50%",
                textStyle:{
                          fontSize: 30,//大小
                }
            }],
            tooltip: {
                trigger: 'axis'
            },
            xAxis: {
                type: 'category',
                data: []
            },
            yAxis: {
                type: 'value',
                max:1
            },
            series: [
                {
                data: [2],
                type: 'line'
                }
            ]
            };
            document.getElementById("WaveGraph").removeAttribute("_echarts_instance_");    
        myChart2 = echarts.init(document.getElementById('WaveGraph'),"mydark");
        myChart2.setOption(Option)
    })
    let timestampToTime=((timestamp)=>{
      var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
      var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
      var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()) + '.';
      var ms = (timestamp % 1000).toString();
      while (ms.length < 3) {
        ms = '0' + ms;
      }
      //var nowtime = new Date(Y+M+D+h+m+s);
      return Y + M + D + h + m + s + ms;
    })
    onMounted(()=>{
        console.log('节点',TmyChart);
        // nextTick(()=>{
        //     DrawGraph()
        // }) 
    })
    onBeforeUnmount(()=>{
        console.log('节点',TmyChart);
        // var myChart = echarts.init(document.getElementById('TrendGraph'),"mydark");
        // var myChart2 = echarts.init(document.getElementById('WaveGraph'),"mydark");
        // myChart.clear();
        // myChart2.clear();
    })
    // let index = ref('RealtStatus')
    // let handleSelect = (key, keyPath) => {
    //   index.value = key;
    //   router.push({
    //     path: '/' + key
    //   })
    // }
    // let activeIndex = computed(() => {
    //   // console.log(router.options.routes[0].redirect.replace('/', ''));
    //   // console.log('打印路由', route.path.replace('/', ''));
    //   return route.path.replace('/', '');
    // })
    return {
        show,
        TmyChart,
        DrawGraph,
        DrawGraph2,
        DrawGraphNull,
        DrawGraphNull2
    //   activeIndex,
    //   handleSelect
    }
  },
}
</script>
